module.exports = __webpack_public_path__ + "static/media/help.57926fec.svg";